<template>
    <div id=app :class="$route.name">

        <transition name="fade" appear>

            <div v-if="isLoading" class=loading>

                <span class=text>Loading<span class=mask>Loading</span></span>

            </div>

        </transition>

        <div v-if="!isLoading">

            <transition name="fade" appear>

                    <router-view :key="$route.path" />

            </transition>

        </div>

        <FixedNav></FixedNav>

        <a class=mod-logo href="https://mod.org.au/">
            <img :src="require('@/assets/images/mod-logo.svg')">
        </a>

        <div class=floaty-background>

            <ul class=clouds>
                <li class=cloud-1 data-depth="0.60"><img :src="require('@/assets/images/cloud-1.svg')"></li>
                <li class=cloud-2 data-depth="0.80"><img :src="require('@/assets/images/cloud-2.svg')"></li>
                <li class=cloud-3 data-depth="0.70"><img :src="require('@/assets/images/cloud-3.svg')"></li>
                <li class=cloud-4 data-depth="0.90"><img :src="require('@/assets/images/cloud-4.svg')"></li>
                <li class=cloud-5 data-depth="0.75"><img :src="require('@/assets/images/cloud-5.svg')"></li>
            </ul>

            <div class=fog>
                <img class=fog-1 data-depth="1.3" :src="require('@/assets/images/fog.png')">
                <img class=fog-2 data-depth="1.6" :src="require('@/assets/images/fog-2.png')">
                <img class=fog-3 data-depth="1.2" :src="require('@/assets/images/fog-2.png')">
            </div>

            <div class=orbs>
                <div class=orb-1 data-depth="0.10"></div>
                <div class=orb-2 data-depth="0.15"></div>
                <div class=orb-3 data-depth="0.09"></div>
                <div class=orb-4 data-depth="0.21"></div>
                <div class=orb-5 data-depth="0.13"></div>
            </div>

        </div>
    </div>
</template>

<script>
    import FixedNav from './components/FixedNav.vue'
    import Parallax from 'parallax-js'
    import axios    from 'axios'

    export default {
        name : 'App',
        components : {
            FixedNav,
        },
        methods : {
            setVHprop() {
                let vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            }
        },
        data() {
            return {
                isLoading : true,
            }
        },
        created() {
            // Single WP origin URL, set per environment (e.g. Forge)
            const wpBaseUrl = process.env.VUE_APP_WP_URL + '/up-close/';
            const wpApi     = process.env.VUE_APP_WP_URL + '/wp-json/wp/v2/mod_upclose?per_page=99';

            axios.get( wpApi )
            .then( response => {
                let routes = [];
                let postsArray = response.data;
                let posts = {};

                for( let post of postsArray ) {
                    posts[post.id] = post;
                }

                for( let p in posts ) {
                    let post = posts[p];

                    // Make children more useable
                    for( let c in post.children ) {
                        post.children[c] = posts[c];
                        post.children[c].parent = posts[post.children[c].parent] || null;
                    }

                    if( post.parent == 0 && post.slug != 'about' && post.slug != 'events' ) {
                        post.template = 'MenuPage';
                    }
                    else if( !post.template ) {
                        post.template = 'RichTextPage';
                    }

                    // Setup path and pathName for routing.
                    post.path = post.link.replace( wpBaseUrl, '').slice(0, -1);
                    post.pathName = post.path.replace('/','-');

                }

                for( let p in posts ) {
                    let post = posts[p];
                    let parentPath = null;

                    // Determine path parent
                    if( post.parent ) {
                        // Ugly hack for comic pages.
                        if( post.parent.slug == 'comic') {
                            parentPath = post.parent.parent.pathName;
                        }
                        else {
                            parentPath = post.parent.pathName;
                        }
                    }
                    else {
                        parentPath = 'home';
                    }

                    // Create the routes.
                    routes.push({
                        path : '/' + post.path ,
                        name : post.pathName   ,
                        component: () => import(/* webpackChunkName: "inside-us" */ './views/Page.vue'),
                        meta : {
                            parent : parentPath,
                        },
                        props : {
                            post : post,
                        }
                    });

                }

                routes.push( {
                    path : '*',
                    name : 'not-found',
                    component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue'),
                    meta : {
                    parent : 'home'
                    }
                });

                this.$router.matcher.addRoutes( routes );

                // If we're not on the home page reload the route.
                if( this.$route.path != '/' ) {
                    this.$router.push( this.$route.path );
                }

                this.isLoading = false;
            })
            .catch( e => {
                console.log(e);
                this.isLoading = false;
            });

            window.addEventListener( 'resize', this.setVHprop);

            this.setVHprop();
        },
        mounted() {
            var clouds = document.querySelector('.clouds');
            new Parallax(clouds);

            var fogs = document.querySelector('.fog');
            new Parallax(fogs);

            var orbs = document.querySelector('.orbs');
            new Parallax(orbs);
        }
    }
</script>

<style src="@/styles/frontend.css"></style>
